import React = require("react");
import ReactDOM = require("react-dom");
import Constants = require("DistributedTask/Scripts/Constants");

import VssContext = require("VSS/Context");
import { ModalDialogO, IModalDialogOptions } from "VSS/Controls/Dialogs";
import { LWPComponent } from "VSSPreview/Flux/Components/LWP";
import { SecurityHelper } from "DistributedTask/Scripts/Components/SecurityDialog";

export interface IPipelinePermissionsDialogOptions extends IModalDialogOptions {
    resourceType: string,
    resourceId: string,
    title?: string
}

export class PipelinePermissionsDialog extends ModalDialogO<IPipelinePermissionsDialogOptions> {
    public initializeOptions(options?: IPipelinePermissionsDialogOptions) {
        this._resourceType = options.resourceType;
        this._resourceId = options.resourceId;

        super.initializeOptions($.extend({
            width: 800,
            height: 325,
            title: options.title,
            buttons: null
        }, options));
    }

    public initialize() {
        super.initialize();
        var vssContext = VssContext.getDefaultWebContext();
        var canOpenAccess = SecurityHelper.hasLibraryPermission(vssContext.project.id, 2);
        canOpenAccess.then((hasOpenPermission: boolean) => {
            if (this._resourceType == Constants.LibraryConstants.SecureFile)
            {
                var canRestrictAccess = SecurityHelper.hasSecureFilePermission(vssContext.project.id, this._resourceId, 2);
                canRestrictAccess.then((hasRestrictPermission: boolean) => {
                    this.render(hasOpenPermission, hasRestrictPermission);
                });
            }
            else
            {
                var canRestrictAccess = SecurityHelper.hasVariableGroupPermission(vssContext.project.id, Number(this._resourceId), 2);
                canRestrictAccess.then((hasRestrictPermission: boolean) => {
                    this.render(hasOpenPermission, hasRestrictPermission);
                });
            }
        });
    }

    public render(canOpenAccess: boolean, canRestrictAccess: boolean){
        ReactDOM.render<any>(<LWPComponent
            dependencies={["ms.vss-distributedtask-web.dt-security"]}
            wrappedProps={{
                resourceType: this._resourceType,
                resourceId: this._resourceId,
                noAuthorizedPipelinesViewLearnMoreLink: "https://aka.ms/yamlauthz",
                noRestrictionsViewLearnMoreLink: "https://aka.ms/yamlauthz",
                canOpenAccess: canOpenAccess,
                canRestrictAccess: canRestrictAccess
            }}
            wrappedType="pipelines-authorization-component"
        />, this._element[0]);
    }

    public close(): void {
        ReactDOM.unmountComponentAtNode(this._element[0]);
        super.close();
    }

    private _resourceType: string;
    private _resourceId: string;
}